import React from 'react';
import { useNavigate } from 'react-router-dom';

const Home = () => {
  const navigate = useNavigate();
  
  const programs = [
    {
      id: 1,
      title: 'Class',
      description: 'Enroll in our educational classes and skill development programs.',
      icon: '📚',
      link: '/class/center',
    },
    {
      id: 2,
      title: 'Camp',
      description: 'Join our exciting summer camps with activities for all age groups.',
      icon: '🏕️',
      link: '/camp/center',
    },
    {
      id: 3,
      title: 'Retreat',
      description: 'Experience spiritual growth and relaxation at our retreat programs.',
      icon: '🧘',
      link: '/retreat/center',
    },
    {
      id: 4,
      title: 'Tiffin',
      description: 'Subscribe to our healthy meal delivery service.',
      icon: '🍱',
      link: '/tiffin/center',
    },
    {
      id: 5,
      title: 'Email',
      description: 'Send bulk payment confirmation emails to multiple recipients.',
      icon: '📧',
      link: '/email',
    },
  ];

  return (
    <div className="min-h-screen">
      {/* Programs Section */}
      <section className="py-16 bg-gradient-to-br from-blue-50 via-purple-50 to-pink-50">
        <div className="container-custom">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {programs.map((program) => {
              const isEnabledTile = program.title === 'Class' || program.title === 'Email';
              const isDisabled = !isEnabledTile;
              
              return (
                <div
                  key={program.id}
                  className={`item-card p-6 text-center ${
                    isEnabledTile ? 'cursor-pointer' : 'opacity-50 cursor-not-allowed'
                  }`}
                  onClick={() => {
                    if (isEnabledTile) {
                      navigate(program.link);
                    }
                  }}
                >
                  <div className="text-6xl mb-4">{program.icon}</div>
                  <h3 className="text-2xl font-bold text-gray-800 mb-2">{program.title}</h3>
                  <p className="text-base text-gray-600 leading-relaxed mb-4">{program.description}</p>
                  {isEnabledTile && (
                    <div className="mt-auto">
                      <div className="bg-white hover:bg-gray-50 text-gray-700 font-semibold py-3 px-5 rounded-full border-2 border-gray-200 transition shadow-sm hover:shadow-md text-base">
                        Explore
                      </div>
                    </div>
                  )}
                  {isDisabled && (
                    <div className="mt-auto">
                      <div className="bg-gray-200 text-gray-500 font-semibold py-3 px-5 rounded-full border-2 border-gray-300 text-base">
                        Coming Soon
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Features Section - Compact White Design */}
      <section className="py-12 bg-white">
        <div className="container-custom">
          {/* Compact Title */}
          <div className="text-center mb-8">
            <h2 className="text-3xl font-bold text-gray-800 mb-2">
              Why Choose Us?
            </h2>
            <div className="w-20 h-1 bg-gradient-to-r from-blue-500 to-purple-500 mx-auto rounded-full"></div>
          </div>

          {/* Compact Feature Cards */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {/* Expert Instructors */}
            <div className="group bg-white rounded-2xl p-6 border-2 border-gray-100 hover:border-blue-300 transition-all duration-300 hover:shadow-lg">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-gradient-to-br from-yellow-400 to-orange-500 rounded-xl flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform duration-300">
                  <span className="text-2xl">👨‍🏫</span>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-gray-800 mb-2">
                    Expert Instructors
                  </h3>
                  <p className="text-sm text-gray-600 leading-relaxed">
                    Learn from experienced and certified professionals.
                  </p>
                </div>
              </div>
            </div>

            {/* Flexible Scheduling */}
            <div className="group bg-white rounded-2xl p-6 border-2 border-gray-100 hover:border-purple-300 transition-all duration-300 hover:shadow-lg">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-gradient-to-br from-pink-400 to-purple-500 rounded-xl flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform duration-300">
                  <span className="text-2xl">📅</span>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-gray-800 mb-2">
                    Flexible Scheduling
                  </h3>
                  <p className="text-sm text-gray-600 leading-relaxed">
                    Choose programs that fit your schedule.
                  </p>
                </div>
              </div>
            </div>

            {/* Community Focus */}
            <div className="group bg-white rounded-2xl p-6 border-2 border-gray-100 hover:border-blue-300 transition-all duration-300 hover:shadow-lg">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-gradient-to-br from-blue-400 to-cyan-500 rounded-xl flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform duration-300">
                  <span className="text-2xl">🤝</span>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-gray-800 mb-2">
                    Community Focus
                  </h3>
                  <p className="text-sm text-gray-600 leading-relaxed">
                    Be part of a supportive community.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
